import { render, staticRenderFns } from "./DemDetCalculatorPop.vue?vue&type=template&id=5750dc4a&scoped=true"
import script from "./DemDetCalculatorPop.vue?vue&type=script&lang=js"
export * from "./DemDetCalculatorPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5750dc4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5750dc4a')) {
      api.createRecord('5750dc4a', component.options)
    } else {
      api.reload('5750dc4a', component.options)
    }
    module.hot.accept("./DemDetCalculatorPop.vue?vue&type=template&id=5750dc4a&scoped=true", function () {
      api.rerender('5750dc4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/DemDetCalculatorPop.vue"
export default component.exports